import { getDocs, collection } from "@firebase/firestore";
import { hideLoading, setBidsList, showLoading } from "./bids-home-slice";

export const getBidsService = async (dispatch, db, coll) => {
    dispatch(showLoading());
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setBidsList(data));
        });
    } catch(e) {
        console.error("BidsList getBidsService error: ", e);
    }
    finally {
        // This block will always execute, even if there's an exception
        dispatch(hideLoading()); // Make sure this is here
    }
};